import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard/AuthCard';
import { LoginForm } from '../components/LoginForm/LoginForm';
import { useAuth } from '../hooks/useAuth';
import { getReturnPath } from '../authConstants';

export function LoginPage() {
  const { isAuthenticated, isInitialized } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();

  // Once signed in, go back to the page remembered when the session ended or a protected
  // route redirected here — /login is replaced in the history (HOMCO-1269).
  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      navigate(getReturnPath(state), { replace: true });
    }
  }, [isAuthenticated, isInitialized, navigate, state]);

  return (
    <AuthCard>
      <LoginForm />
    </AuthCard>
  );
}
